import { Text } from '@wework/dieter-ui'
import React from 'react'
import holdPattern from '../../assets/images/holdPattern.png'

export enum SpaceStatus {
  AVAILABLE,
  ONHOLD,
  PENDING,
  OCCUPIED,
  NOTLINKED,
  BPO,
}

interface Props {
  status: SpaceStatus
  text?: string
}

export default function StatusTag({
  status = SpaceStatus.NOTLINKED,
  text = '',
}: Props) {
  const getText = () => {
    switch (status) {
      case SpaceStatus.AVAILABLE:
        return `Available ${text}`
      case SpaceStatus.ONHOLD:
        return '🔒 On hold'
      case SpaceStatus.PENDING:
        return '🔏 Pending paperwork'
      case SpaceStatus.OCCUPIED:
        return 'Occupied'
      case SpaceStatus.BPO:
        return 'Bookable Private Office'
      default:
        return 'Not linked'
    }
  }
  const getStyle = () => {
    switch (status) {
      case SpaceStatus.AVAILABLE:
        return styles.available
      case SpaceStatus.ONHOLD:
      case SpaceStatus.PENDING:
        return styles.dotted

      case SpaceStatus.OCCUPIED:
        return styles.occupied
      case SpaceStatus.BPO:
        return styles.occupied
      default:
        return styles.notLinked
    }
  }
  return (
    <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
      <div style={{ ...styles.root, ...getStyle() }}>
        <Text style={styles.text}>{getText()}</Text>
      </div>
    </div>
  )
}

const styles = {
  root: {
    height: 24,
    padding: '4px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  occupied: {
    backgroundColor: '#FFB2BB',
  },
  available: {
    backgroundColor: '#E5FFFD',
    border: '1px solid #00665E',
  },
  notLinked: {
    backgroundColor: '#CCCCCC',
  },
  dotted: {
    backgroundImage: `url(${holdPattern})`,
    backgroundColor: '#E5FFFD',
  },
  text: {
    fontSize: 10,
  },
}
